// plan-12 S02: color bleed pulse — CSS filter channel separation on <main>

import type { DrawPass } from '../canvas'

const MIN_INTERVAL = 32_000
const MAX_INTERVAL = 48_000
const EVENT_DURATION = 320

export function createColorBleed(reduced: boolean): DrawPass {
  if (reduced) return () => {}

  let nextEvent = performance.now() + randomInterval()
  let eventStart = 0
  let active = false

  function randomInterval(): number {
    return MIN_INTERVAL + Math.random() * (MAX_INTERVAL - MIN_INTERVAL)
  }

  return (_ctx, _w, _h, t): void => {
    const now = t * 1000
    const main = document.getElementById('vt-app')

    if (!main) return

    if (!active && now >= nextEvent) {
      active = true
      eventStart = now
      main.classList.add('vt-color-bleed')
    }

    if (active) {
      const elapsed = now - eventStart
      if (elapsed >= EVENT_DURATION) {
        active = false
        nextEvent = now + randomInterval()
        main.classList.remove('vt-color-bleed')
      }
    }
  }
}
